import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
import { Star, ShieldCheck, Zap } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function CheckoutSection() {
  const [timeLeft, setTimeLeft] = useState('');
  useEffect(() => {
    let endTime = localStorage.getItem('countdown_end');
    if (!endTime) {
      endTime = (Date.now() + 24 * 60 * 60 * 1000 - 12 * 60 * 1000).toString(); // ~23:48:00
      localStorage.setItem('countdown_end', endTime);
    }
    const timer = setInterval(() => {
      const now = Date.now();
      const distance = parseInt(endTime!) - now;
      if (distance < 0) {
        setTimeLeft('00:00:00');
        clearInterval(timer);
        return;
      }
      const h = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const m = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const s = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="checkout" className="py-12 md:py-20 px-4 bg-beige relative scroll-mt-20" data-id="element-72">
      <div className="max-w-3xl mx-auto text-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[32px] shadow-2xl border border-sage/30 relative overflow-hidden" data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/tNEW3FAGHwfJ6rwoHqK5zX/3._Oferta.png" alt="Sistema de Reprogramación Interna de 30 Días - Accede a todo hoy por $9,99 USD con todos los bonos incluidos" className="w-full block" data-id="element-75" />
          <div className="p-6 md:p-12" data-id="element-76">
            <div className="flex items-center justify-center gap-2 text-xs md:text-sm font-bold text-teal mb-6 flex-wrap" data-id="element-77">
              <div className="flex text-gold" data-id="element-78">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-79" />)}
              </div>
              <span data-id="element-80">+2.400 mujeres transformadas</span>
            </div>

            <h2 className="font-heading font-bold text-xl md:text-3xl text-neutral-gray mb-6 md:mb-8 tracking-wide" data-id="element-81">
              ACCEDE HOY AL SISTEMA
            </h2>

            <div className="bg-urgency text-white text-[10px] md:text-xs font-bold px-3 py-1.5 rounded-full inline-block mb-4 animate-pulse shadow-md" data-id="element-82">
              🔥 OFERTA ESPECIAL · PRECIO DE LANZAMIENTO
            </div>

            <p className="text-neutral-gray text-base md:text-lg mb-2" data-id="element-83">
              Valor total:{' '}
              <PriceDisplay amountUSD={67} className="line-through text-gold" data-id="element-84" />
            </p>

            <div className="mb-8" data-id="element-85">
              <span className="block text-sm font-bold text-teal uppercase tracking-widest mb-1" data-id="element-86">
                💥 Hoy solo: 💥
              </span>
              <PriceDisplay amountUSD={9.99} className="font-display font-bold text-[44px] sm:text-[56px] md:text-[72px] text-teal leading-none" data-id="element-87" />
            </div>

            <a href="https://rutinaspracticas.com/cart/53011644547394:1" onClick={() => trackAddToCart()} className="block w-full bg-teal hover:bg-teal-light text-white font-bold text-base md:text-xl py-5 md:py-6 px-4 md:px-8 rounded-full transition-all shadow-[0_8px_30px_rgb(61,90,90,0.3)] hover:shadow-[0_8px_30px_rgb(61,90,90,0.5)] hover:scale-[1.02] mb-4" data-id="element-88">
              ✨ QUIERO MI SISTEMA AHORA
            </a>

            <p className="text-xs text-neutral-gray font-sans mb-6" data-id="element-89">
              Al hacer clic serás redirigida de forma segura al checkout
            </p>

            {timeLeft && <div className="bg-urgency/10 text-urgency font-bold text-sm md:text-base py-2 px-4 md:px-6 rounded-full inline-block mb-6 md:mb-8 border border-urgency/20" data-id="element-90">
                Esta oferta vence en: {timeLeft}
              </div>}

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-8 text-xs md:text-sm font-medium text-teal" data-id="element-91">
              <div className="flex items-center gap-1.5" data-id="element-92">
                <ShieldCheck size={16} className="text-relief" data-id="element-93" />
                <span data-id="element-94">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-95">
                <Zap size={16} className="text-gold" data-id="element-96" />
                <span data-id="element-97">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-98">
                <ShieldCheck size={16} className="text-relief" data-id="element-99" />
                <span data-id="element-100">Garantía 30 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}